export default {
      id: "footer-logo-usage",
      viewBox: "0 0 152 77.749",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#footer-logo",
      toString: function () {
        return this.url;
      }
    }